import { defineMessages } from 'react-intl'

export default defineMessages({
  selectCustomer: {
    id: 'app.containers.NavigationBar.selectCustomer',
    defaultMessage: 'Select Customer',
  },
  customers: {
    id: 'app.containers.NavigationBar.customers',
    defaultMessage: 'Customers',
  },
  selectCompany: {
    id: 'app.containers.NavigationBar.selectCompany',
    defaultMessage: 'Select Company',
  },
  companies: {
    id: 'app.containers.NavigationBar.companies',
    defaultMessage: 'Companies',
  },
  dashboards: {
    id: 'app.containers.NavigationBar.dashboards',
    defaultMessage: 'Dashboards',
  },
  reports: {
    id: 'app.containers.NavigationBar.reports',
    defaultMessage: 'Reports',
  },
  settings: {
    id: 'app.containers.NavigationBar.settings',
    defaultMessage: 'Settings',
  },
  home: {
    id: 'app.containers.NavigationBar.home',
    defaultMessage: 'Home',
  },
  budgets: {
    id: 'app.containers.NavigationBar.budgets',
    defaultMessage: 'Budgets',
  },
  cashFlow: {
    id: 'app.containers.NavigationBar.cashFlow',
    defaultMessage: 'Cash Flow',
  },
  tools: {
    id: 'app.containers.NavigationBar.tools',
    defaultMessage: 'Tools',
  },
  accountSchemes: {
    id: 'app.containers.NavigationBar.accountSchemes',
    defaultMessage: 'Account Schemes',
  },
  accountSchemeTemplates: {
    id: 'app.containers.NavigationBar.accountSchemeTemplates',
    defaultMessage: 'Account Scheme Templates',
  },
  calculationConstants: {
    id: 'app.containers.NavigationBar.calculationConstants',
    defaultMessage: 'Calculation Constants',
  },
  chatDocumentationIndex: {
    id: 'app.containers.NavigationBar.chatDocumentationIndex',
    defaultMessage: 'Chat documentation index',
  },
  reportSchemes: {
    id: 'app.containers.NavigationBar.reportSchemes',
    defaultMessage: 'Report Schemes',
  },
  reportSchemeTemplates: {
    id: 'app.containers.NavigationBar.reportSchemeTemplates',
    defaultMessage: 'Report Scheme Templates',
  },
  users: {
    id: 'app.containers.NavigationBar.users',
    defaultMessage: 'Users',
  },
  allUsers: {
    id: 'app.containers.NavigationBar.allUsers',
    defaultMessage: 'All Users',
  },
  gtScheduledJobs: {
    id: 'app.containers.NavigationBar.gtScheduledJobs',
    defaultMessage: 'GT Scheduled Jobs',
  },
  hangfireJobs: {
    id: 'app.containers.NavigationBar.hangfireJobs',
    defaultMessage: 'Job Queue',
  },
  integrationSourceSystems: {
    id: 'app.containers.NavigationBar.integrationSourceSystems',
    defaultMessage: 'Integration source systems',
  },
  accounts: {
    id: 'app.containers.NavigationBar.accounts',
    defaultMessage: 'Accounts',
  },
  accountingPeriods: {
    id: 'app.containers.NavigationBar.accountingPeriods',
    defaultMessage: 'Accounting Periods',
  },
  dimensions: {
    id: 'app.containers.NavigationBar.dimensions',
    defaultMessage: 'Dimensions',
  },
  integrationLogs: {
    id: 'app.containers.NavigationBar.integrationLogs',
    defaultMessage: 'Integration Logs',
  },
  reportingGroups: {
    id: 'app.containers.NavigationBar.reportingGroups',
    defaultMessage: 'Reporting Groups',
  },
  rollingRuleTemplates: {
    id: 'app.containers.NavigationBar.rollingRuleTemplates',
    defaultMessage: 'Rolling Rule Templates',
  },
  vouchers: {
    id: 'app.containers.NavigationBar.vouchers',
    defaultMessage: 'Vouchers',
  },
  roles: {
    id: 'app.containers.NavigationBar.roles',
    defaultMessage: 'Roles',
  },
  helpCenter: {
    id: 'app.containers.NavigationBar.helpCenter',
    defaultMessage: 'Help Center',
  },
  signedInAs: {
    id: 'app.containers.NavigationBar.signedInAs',
    defaultMessage: 'Signed in as',
  },
  useLightTheme: {
    id: 'app.containers.NavigationBar.useLightTheme',
    defaultMessage: 'Use light theme',
  },
  useDarkTheme: {
    id: 'app.containers.NavigationBar.useDarkTheme',
    defaultMessage: 'Use dark theme',
  },
  switchProfile: {
    id: 'app.containers.NavigationBar.switchProfile',
    defaultMessage: 'Switch Profile',
  },
  logout: {
    id: 'app.containers.NavigationBar.logout',
    defaultMessage: 'Logout',
  },
  company: {
    id: 'app.containers.NavigationBar.company',
    defaultMessage: 'Company',
  },
  customer: {
    id: 'app.containers.NavigationBar.customer',
    defaultMessage: 'Customer',
  },
  noContext: {
    id: 'app.containers.NavigationBar.noContext',
    defaultMessage: 'No context',
  },
  systemSettings: {
    id: 'app.containers.NavigationBar.systemSettings',
    defaultMessage: 'System settings',
  },
  search: {
    id: 'app.containers.NavigationBar.search',
    defaultMessage: 'Search...',
  },
  notifications: {
    id: 'app.containers.NavigationBar.notifications',
    defaultMessage: 'Notifications',
  },
  help: {
    id: 'app.containers.NavigationBar.help',
    defaultMessage: 'Help Center',
  },
  userSettings: {
    id: 'app.containers.NavigationBar.userSettings',
    defaultMessage: 'User Settings',
  },
  toggleSidebar: {
    id: 'app.containers.NavigationBar.toggleSidebar',
    defaultMessage: 'Toggle Sidebar',
  },
  companySettings: {
    id: 'app.containers.NavigationBar.companySettings',
    defaultMessage: 'Company Settings',
  },
})
